import React, {Component} from 'react';
import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';
import Loader from './../../components/Loader/Loader'
import Header from '../../components/FeedingGuidelines/Header/Header';
import fetchFeedingGuidelinesHeaderAction from './../../store/actions/fetch/fetchFeedingGuidelinesHeaderAction';
import * as actionTypes from './../../store/actions/feedingGuidelinesHeaderAction';

import * as pdfOutputAction from './../../store/actions/pdfOutputAction';
import domtoimage from 'dom-to-image';
import OnImagesLoaded from 'react-on-images-loaded';

class FeedingGuidelinesHeader extends Component {

  componentDidMount() {
    const {fetchData} = this.props;
    fetchData();
  }

  doScreenShot() {
    const {screenshots}  = this.props;
    const el = document.getElementById('fc-screenshot-feeding-guidelines-header'); 
    const {setScreenShot, onScreenshotError} = this.props;
    if (el){
      domtoimage.toPng(el)
        .then(function (dataUrl) {
          if (screenshots && screenshots['fc-screenshot-feeding-guidelines-header'] !== dataUrl){
            setScreenShot(dataUrl);
          }
        })
        .catch(function () {
          onScreenshotError();
        });
    } else {
      onScreenshotError();
    }
  }

  render() {
    const {data, pending, ready, error, output} = this.props;

    if(pending || !ready) return (
      <Loader/>
    );

    return (
      <OnImagesLoaded
        onLoaded={this.doScreenShot.bind(this)}
        onTimeout={this.doScreenShot.bind(this)}
        timeout={7000}>
        <Header data={data} output={output} />
      </OnImagesLoaded>
    );
  }
}

const mapStateToProps = state => {
  return {
    data: state.feedingGuidelinesHeaderReducer.data,
    pending: state.feedingGuidelinesHeaderReducer.pending,
    ready: state.feedingGuidelinesHeaderReducer.ready,
    error: state.feedingGuidelinesHeaderReducer.error,
    screenshots: state.pdfOutputReducer.images,
  }
};

const mapDispatchToProps = dispatch => {
  return {
    ...bindActionCreators(
      {
        fetchData: fetchFeedingGuidelinesHeaderAction
      },
      dispatch,
    ),
    defaultValues: () => dispatch({
      type: actionTypes.DEFAULT,
    }),
    setScreenShot: (data) => dispatch({
      type: pdfOutputAction.ADD,
      key: 'fc-screenshot-feeding-guidelines-header',
      data: data,
    }),
    onScreenshotError: () => dispatch({
      type: pdfOutputAction.SCREENSHOT_ERROR,
    }),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(FeedingGuidelinesHeader);
